import { render, staticRenderFns } from "./pangkat.vue?vue&type=template&id=5a49192d"
import script from "./pangkat.vue?vue&type=script&lang=js"
export * from "./pangkat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports